<template lang="pug">
  .details-box-label
    label(:class="{'break-line': breakLine }")
      slot(name="title")
        | {{ title }}
      span.icone-chapado-info(v-if="tooltipComDica" v-ptt-popover.bottom.hover="{content: tooltipComDica}")

    .loading(v-if="loading")

    // use esse slot para nao ter a tag b
    slot(name="cleanBody" v-else-if="$slots.cleanBody")

    b(v-else :class="{'break-line': breakLine }")
      slot(name="body")
        | {{ body }}

    img.copyicon(src="../../../static/images/copy_content.svg" v-if="copyicon"
    @click="copy(body)")

</template>

<script>
export default {
  name: 'DBLabel',
  props: {
    // if this props arent given we will use the slots
    title: {type: String, required: false},
    body: {required: false},
    loading: {type: Boolean, required: false},
    copyicon: {type: Boolean, 'default': false},
    tooltipComDica: {type: String, required: false, 'default': null},
    breakLine: {type: Boolean, 'default': false}, // Permite quebra de linha
  },
  methods: {
    copy (text) {
      navigator.clipboard.writeText(text)
    }
  }
}
</script>

<style lang="scss">
.details-box-label {
  label {
    display: block;
    color: var(--texto-suave);
    font-family: var(--texto-tipografia, var(--front-font));
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 4px;

    .icone-chapado-info {
      padding-left: 2px;
    }

    // Classe para permitir quebra de linha
    &.break-line {
      white-space: normal;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  b {
    color: var(--texto-forte);
    font-family: var(--texto-tipografia, var(--front-font));
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;

    // Classe para permitir quebra de linha
    &.break-line {
      display: block;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-word;
    }
  }

  .loading {
    width: 100%;
    max-width: 80px;
    height: 14px;
    border-radius: var(--raio-pilula);
    background-color: var(--superficie-sutil);
  }

  img {
    visibility: hidden;
    margin-left: 10px;
    width: 15px;
    cursor: pointer;
    color: var(--color-primary);
  }

  &:hover {
    img {
      visibility: visible;
    }
  }
}
</style>
